import React, { useState } from 'react';
import {
  VStack,
  HStack,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from '@chakra-ui/react';

const CarSoundDiagnosisPopup = ({ isOpen, onClose }) => {
  const [selectedSoundSource, setSelectedSoundSource] = useState('wheels');

  const handleUpload = () => {
    console.log('Upload sound for diagnosis');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.500" backdropFilter="blur(2px)" />
      <ModalContent 
        bg="white" 
        borderRadius="30px" 
        mx={4}
        maxW="400px"
        position="fixed"
        bottom={0}
        mb={0}
        borderTopRadius="30px"
        borderBottomRadius="0"
      >
        <ModalBody p={6} textAlign="center">
          {/* Main Question */}
          <Text fontSize="lg" fontWeight="bold" color="black" mb={6}>
            Help us know where the sound is coming from?
          </Text>

          {/* Sound Source Selection */}
          <VStack spacing={4} align="stretch" mb={6}>
            <HStack spacing={3} justify="center">
              <Button
                size="sm"
                variant={selectedSoundSource === 'wheels' ? 'solid' : 'outline'}
                colorScheme={selectedSoundSource === 'wheels' ? 'blue' : 'gray'}
                onClick={() => setSelectedSoundSource('wheels')}
                borderRadius="10px"
                w="88.91px"
                h="27.82px"
                fontSize="xs"
              >
                Wheels
              </Button>
              <Button
                size="sm"
                variant={selectedSoundSource === 'engine' ? 'solid' : 'outline'}
                colorScheme={selectedSoundSource === 'engine' ? 'blue' : 'gray'}
                onClick={() => setSelectedSoundSource('engine')}
                borderRadius="10px"
                w="88.91px"
                h="27.82px"
                fontSize="xs"
              >
                Engine
              </Button>
              <Button
                size="md"
                variant={selectedSoundSource === 'exhaust' ? 'solid' : 'outline'}
                colorScheme={selectedSoundSource === 'exhaust' ? 'blue' : 'gray'}
                onClick={() => setSelectedSoundSource('exhaust')}
                borderRadius="10px"
                w="88.91px"
                h="27.82px"
                fontSize="xs"
              >
                Exhaust
              </Button>
            </HStack>
          </VStack>

          {/* Upload Section */}
          <VStack spacing={4} align="center">
            <Text 
              color="black"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="27px"
              letterSpacing="0%"
              textAlign="center"
            >
              Upload Car Sound for Diagnosis
            </Text>
            <Text 
              color="#9A9898"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="27px"
              letterSpacing="0%"
              textAlign="center"
            >
              Hearing something unusual?
            </Text>
            <Text 
              color="#9A9898"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="27px"
              letterSpacing="0%"
              textAlign="center"
            >
              Upload the sound and we'll take a look
            </Text>
            <Button
              colorScheme="blue"
              size="lg"
              borderRadius="8px"
              w="88.91px"
              h="27.82px"
              fontSize="xs"
              onClick={handleUpload}
            >
              Upload
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CarSoundDiagnosisPopup; 